import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon, Add } from '@mui/icons-material';
import Toolbar from 'components/Toolbar/Toolbar';
import CompanyCreate from './Form/CompanyCreate';

const CompanyToolbar = ({
  title = '', isFetching, refetch, backLink, data = null, userData = null
}) => (
  <Toolbar
    title={title}
    backLink={backLink}
    action={(
      <>
        {data && (userData.is_staff || userData.is_superuser) ? (
          <CompanyCreate
            title="Create Company"
            button={{
              content: (
                <>
                  <Add />
                  Create
                </>
              ),
              color: 'primary',
              variant: 'standard',
              state: 'outlined'
            }}
            refetch={refetch}
          />
        ) : null}
        {isFetching ? (
          <div style={{
            height: 48, width: 48, display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
          >
            <CircularProgress size={22} />
          </div>
        ) : (
          <Tooltip title="Sync">
            <IconButton
              id="SyncButton"
              onClick={(e) => {
                e.preventDefault();
                refetch();
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
    )}
  />
);
export default CompanyToolbar;
